

import React, { useEffect, useState, useCallback, useContext, Fragment,useRef } from "react";
import {
  CircularProgress,
  Divider,
  Tooltip,
  Typography,
  IconButton,
  Badge,
  Grid,
  Button,
  AppBar,
  Tabs,
  Tab,
  Box
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { NoteAdd as NoteAddIcon } from "@material-ui/icons";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import TabUnselectedIcon from '@material-ui/icons/TabUnselected';
import ScenarioGroupingFlow from "./../ScenarioGroupingFlow";
import options from "./options";
import CustomPagination from "../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import VariationsSelection from "../../cm_close_loop/ScenarioListing/selectVariation";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import HelperComponent from "../../cm_shared/Reporting/CustomHelper/index";
import HelpIcon from "@material-ui/icons/Help";
import BulkDownloadModal from "../../cm_shared/CMBulkDownloadPopup/index";
import BulkDownloadConfirmationModal from "../../cm_shared/CMBulkDownloadConfirmation/index";
import ConditionalFilter from "../../cm_shared/CMConditionalFilter";
import ClearIcon from "@material-ui/icons/Clear";
import { FilterList } from "@material-ui/icons";
import styled from "styled-components";
import PRScenarioLogicalNameListing from "./PRScenariosLogicalBased";
import { LoadingContext } from "./../../../../context/spinnerContext"

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 400px)
  }
`;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function PRScenarioListing(props) {
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [approveLoading, setApproveLoading] = useState(false);
  const [approveList, setApproveList] = useState([]);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [savedFilters, setSavedFilters] = useState([]);
  const [columns, setColumns] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [modalForVariation, setModalForVariation] = useState(false);
  const [regionDateAllSelect,setRegionDateAllSelect] = useState({});
  const [allSelect, setAllSelect] = useState(false);
  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [clearRows, setClearRows] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [isBulkDownloadPopupOpen, setBulkDownloadPopup] = useState(false);
  const [downloadConfirm, setDownloadConfirm] = useState(false);
  const [bulkDownloadRes, setBulkDownloadResp] = useState(null);
  const [modelOptions, setModelOptions] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({});
  const [options, setOptions] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [regionData, setRegionData] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [cartItemsForGroup, setCartItemsForGroup] = useState([]);
  const [selectHandleObj, setSelectHandleObj] = useState({});
  const currentFiltersRef = useRef(currentFilters);


  useEffect(() => {
    currentFiltersRef.current = currentFilters;
  }, [currentFilters]);
  const [tabs, setTabs] = useState([]);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [currentRowSelection, setCurrentRowSelection] = useState(null);
  const handleTabChange = async (event, newValue) => {
    setTabValue(newValue);
    setEventsPerPage(10);
    setPage(0)
    if(eventsPerPage===10 && page===0){
      fetchRegionData({index: newValue})
    }
  };

  const handleSort = (column, direction) => {
    setCurrentRowSelection(null)
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const onSelectRow = async (newRow, deSelect = false) => {
    if (deSelect) {
      const index = selectedRows.findIndex(
        (row) => row.scenario_uuid === newRow.scenario_uuid
      );
      const newArray = [
        ...selectedRows.slice(0, index),
        ...selectedRows.slice(index + 1),
      ];
      setSelectedRows(newArray);
    } else setSelectedRows((prev) => [...prev, newRow]);
  };

  const selectAll = async (allRow, currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some((item2) => item2.scenario_uuid === item1.scenario_uuid)
    );
    const newAllArray = allRow.filter(
      (item1) =>
        !selectedRows.some((item2) => item2.scenario_uuid === item1.scenario_uuid)
    );
    setSelectedRows([...newArray, ...newAllArray]);
  };

  const deselectAll = async (currentRow) => {
    const newArray = selectedRows.filter(
      (item1) =>
        !currentRow.some((item2) => item2.scenario_uuid === item1.scenario_uuid)
    );
    setSelectedRows([...newArray]);
  };

  
  // const handleChange = async (event) => {
  //   setSelectedRows(event.selectedRows);
  // };

  const bulkDownload = async () => {
    setDownloadConfirm(false);
    try {
      setIsLoading(true);
      const fileList = selectedRows.map((item) => {
        return { file: item.scenario_path };
      });
      const payload = {
        initiated_from: "PR Scenario Listing",
        download_file_name: "PR_Scenarios",
        page_type: "PR",
        files: fileList
      }
      const resp = await axios.post(
        process.env.REACT_APP_API_GATEWAY_URL+"/bulk-download",
        payload
      );
      setBulkDownloadResp(JSON.parse(resp.data));
      setBulkDownloadPopup(true);
    } catch(err) {
      console.log('err', err);
    } finally {
      setClearRows(!clearRows);
      setSelectedRows([]);
      setIsLoading(false)
    }
  };

  const onCloseBulkDownloadPopup = () => {
    setBulkDownloadPopup(false);
    if (bulkDownloadRes.statusCode === 200) {
      const match = bulkDownloadRes.body.split('name: ')[1];
      window.open(`${window.location.origin}/download_archive_list?latestDownload=${match}`, '_blank');
    }
  }

  // const handleDownload = async (filePath) => {
  //   const fileToDownload = await axios.post("/generate-presigned-url", {
  //     s3_location: filePath,
  //   });
  //   window.open(fileToDownload.data.presigned_url);
  // };


  const fetchFilterOptions = async () => {
    const response = await axios.post(
      "/cm/close_loop/fetch_filters_for_page_v2",
      {
        page_filter: "open_cm_loop_base_scenerio_pr_filter"
      }
    );


    let filtersToSet = {}
    const filtersReceived = response.data[0] ? response.data[0].filters : {}
    Object.entries(filtersReceived).map((filterDetails) => {
      if (filterDetails[1].visible === true) {
        filtersToSet[filterDetails[0]] = filterDetails[1]
      }
    })

    setOptions(filtersToSet)
  };

  const handleClose = () => {
    setIsOpen(false);
  }

  const proceedToGetVariations = async (count, date, filters) => {
    console.log("filters inside proceedToGetVariations", filters); 

    try {
      setIsLoading(true);
      const response = await axios.post(
        "/cm/open_loop/fetch_scenario_by_date",
        {
          "open_loop_type": "PR",
          "page_number_record": 1,
          "page_size_record": count === 'all' ? count : parseInt(count),
          "region": tabs[tabValue].key,
          "timestamp": date,
          searchOptions: filters ? filters:{}
      });
      const arrItems = [...cartItems, ...response.data.data];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setCartItems(uniqueItems);
      setModalForVariation(false);
      if (count === 'all') onClickClose();
      else {
        if (count > response.data.total_records) {
          setBulkDownloadResp({body: `For a selected Date, maximum count of scenarios are ${response.data.total_records}. Those have been added to cart.`})
          setBulkDownloadPopup(true);
        }
        setIsOpen(false);
      }
      updateSelectArr(`${date}_${tabs[tabValue].key}`, response.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }
  const updateSelectArr = (val, arr) => {
    if (selectHandleObj[val]) {
      const arrItems = [...selectHandleObj[val], ...arr];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setSelectHandleObj(preVal => ({
        ...preVal,
        [val]: uniqueItems
      }));
    } else {
      setSelectHandleObj(preVal => ({
        ...preVal,
        [val]: arr
      }));
    }
  }
  const onClickClose = () => {
    setIsOpen(false);
    setModalForVariation(false);
    setBulkDownloadPopup(false);
  }

  const addItemsForGroup = (row) => {
    setCartItems((prev) => [...prev, row]);
    updateSelectArr(`${row.date_from_folder}_${tabs[tabValue].key}`, [row]);
  }

  const initialColumns = [
    {
      name: "Date",
      selector: "date_from_folder",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          {row.date_from_folder}
        </div>
      ),
    },
    // {
    //   name: "Scenario Name",
    //   selector: "scenario_name",
    //   sortable: true,
    //   reorder: true,
    //   grow: 3,
    //   cell: (row) => (
    //     <div style={{ flexWrap: "wrap" }}>
    //       {row.scenario_name.split(/\.zip|\.csv/)[0]}
    //     </div>
    //   ),
    // },
    // {
    //   name: "Scenario UUID",
    //   selector: "scenario_uuid",
    //   sortable: true,
    //   reorder: true,
    //   cell: (row) => (
    //     <div style={{ flexWrap: "wrap" }}>{row.scenario_uuid}</div>
    //   ),
    // },
    
    {
      name: "Updated On",
      selector: "updated_at",
      sortable: true,
      reorder: true,
      cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.updated_at}</div>,
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      reorder: true,
      cell: (row) => {
        const isInCart = regionDateAllSelect[row.scenario_uuid]
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {row.quality_check_status === "good" ? (
              <Tooltip placement="top" title={<h6>Approve</h6>}>
                <IconButton
                  onClick={() => handleApprove(row.scenario_uuid, "PR")}
                >
                  {approveLoading && approveList.includes(row.scenario_uuid) ? (
                    <CircularProgress size={24} />
                  ) : (
                    <ThumbUpIcon />
                  )}
                </IconButton>
              </Tooltip>
            ) : (
              // <Tooltip
              //   placement="top"
              //   title={
              //     isInCart ? <h6>Remove from Group</h6> : <h6>Add to Group</h6>
              //   }
              // >
              //   <IconButton
              //     aria-label={isInCart ? "remove" : "add"}
              //     onClick={() =>
              //       isInCart
              //         ? handleRemoveFromCart(row)
              //         : handleAddToCart(row)
              //     }
              //   >
              //     {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
              //   </IconButton>
              // </Tooltip>
              <div>
                {(tabs.length > 0 && `${row.date_from_folder}_${tabs[tabValue].key}` in selectHandleObj
                && selectHandleObj[tabs.length > 0 && `${row.date_from_folder}_${tabs[tabValue].key}`].length > 0
                && cartItems.length > 0) ?
                <Tooltip placement="top" title={<h6>Deselect Scenarios</h6>}>
                <IconButton
                  onClick={() => handleDeselect(tabs.length > 0 && `${row.date_from_folder}_${tabs[tabValue].key}`)}
                >
                  <TabUnselectedIcon />
                </IconButton>
                </Tooltip> :
                <Tooltip placement="top" title={<h6>Select Scenarios</h6>}>
                <IconButton
                  onClick={() => handleModal(
                    <VariationsSelection
                      logicalName={row.date_from_folder}
                      // getVariations={proceedToGetVariations}
                      closeKapDailog={onClickClose}
                      getVariations={(count, date) => proceedToGetVariations(count, date, currentFiltersRef.current)}
                    />,
                    true,
                    true,
                    true
                  )}
                >
                  <SelectAllIcon />
                </IconButton>
                </Tooltip>}
              </div>
            )}
          </div>
        );
      },
    },
    // {
    //   name: "Actions",
    //   selector: "actions",
    //   sortable: true,
    //   reorder: true,
    //   cell: (row) => {
    //     const isInCart = cartItems.some(
    //       (item) => item.scenario_uuid === row.scenario_uuid
    //     );
    //     return (
    //       <div style={{ display: "flex", justifyContent: "space-around" }}>
    //         {row.quality_check_status === "good" ? (
    //           <Tooltip placement="top" title={<h6>Approve</h6>}>
    //             <IconButton
    //               onClick={() => handleApprove(row.scenario_uuid, "PR")}
    //             >
    //               {approveLoading && approveList.includes(row.scenario_uuid) ? (
    //                 <CircularProgress size={24} />
    //               ) : (
    //                 <ThumbUpIcon />
    //               )}
    //             </IconButton>
    //           </Tooltip>
    //         ) : (
    //           <Tooltip
    //             placement="top"
    //             title={
    //               isInCart ? <h6>Remove from Group</h6> : <h6>Add to Group</h6>
    //             }
    //           >
    //             <IconButton
    //               aria-label={isInCart ? "remove" : "add"}
    //               onClick={() =>
    //                 isInCart
    //                   ? handleRemoveFromCart(row.scenario_uuid)
    //                   : handleAddToCart(row)
    //               }
    //             >
    //               {isInCart ? <RemoveCircleIcon /> : <AddIcon />}
    //             </IconButton>
    //           </Tooltip>
    //         )}

    //         <Tooltip placement="top" title={<h6>Delete</h6>}>
    //           <IconButton
    //             aria-label="delete"
    //             onClick={() => {
    //               setDeleteScenarioUuid({
    //                 scenario_uuid: row.scenario_uuid,
    //                 scenario_name: row.scenario_name,
    //                 scenario_version: row.scenario_version,
    //               });
    //               setConfirmDeleteOpen(true);
    //             }}
    //           >
    //             <DeleteIcon />
    //           </IconButton>
    //         </Tooltip>
    //         <Tooltip placement="top" title={<h6>Download</h6>}>
    //           <IconButton
    //             aria-label="download"
    //             onClick={() => handleDownload(row.scenario_path)}
    //           >
    //             <CloudDownloadIcon />
    //           </IconButton>
    //         </Tooltip>
    //       </div>
    //     );
    //   },
    // },
  ];

  let baseUrl = "data:image/png;base64,";

  const handleResetForm = () => {
    setSavedFilters([]);
    setColumns(initialColumns);
    setEventsPerPage(10);
    setPage(0);
    setCurrentFilters({});
    // fetchScenarioCollectionNew();
  };

  // const generateFilterColumns = (filters) => {
  //   console.log("Inside generate filter columns", filters);
  //   if (!filters || !Array.isArray(filters)) {
  //     return [];
  //   }

  //   return filters.flatMap((filterGroup) => {
  //     return Object.keys(filterGroup)
  //       .map((filterKey) => {
  //         const filterValues = filterGroup[filterKey];

  //         if (options[filterKey]) {
  //           return {
  //             name: options[filterKey].props.label,
  //             selector: options[filterKey].selector,
  //             sortable: true,
  //             reorder: true,
  //           };
  //         }

  //         return null;
  //       })
  //       .filter((column) => column !== null);
  //   });
  // };

  // const fetchSelectOptions = async () => {
  //   const response = await axios.post(
  //     "/cm/close_loop/fetch-carmaker_model_record_V2"
  //   );
  //   setModelOptions(response.data);

  //   if (response.data.length > 0) {
  //     const defaultSelectValue = response.data[0]._id;
  //     setSelectValue(defaultSelectValue);
  //   }
  // };

  // const handleSelectChange = (event) => {
  //   const newSelectValue = event.target.value;
  //   setSelectValue(newSelectValue);
  //   const newSearchOptions = JSON.stringify([
  //     { model_record: [newSelectValue] },
  //   ]);
  //   setPage(0);
  //   setCartItems([]);
  //   setCurrentFilters(newSearchOptions);
  //   fetchScenarioCollectionNew(newSearchOptions);
  // }

  
  const handleAdvancedFilterSearch = (value, savedFiltersPassed) => {

    // setAdvancedSearchString(value);
    setSavedFilters(savedFiltersPassed);
    setIsOpen(false);

    // const newColumns = generateFilterColumns(value);
    // console.log("NEW COLUMNS", newColumns);
    // setColumns([
    //   {
    //     name: "Scenario Name",
    //     selector: "scenario_name",
    //     sortable: true,
    //     reorder: true,
    //     cell: (row) => (
    //       <div style={{ flexWrap: "wrap" }}>
    //         {row.scenario_name.split(".csv")[0]}
    //       </div>
    //     ),
    //   },
    //   ...newColumns,
    //   ...initialColumns.filter((column) => column.name !== "Scenario Name"),
    // ]);

    const filters = JSON.stringify(value);
    setCurrentFilters(filters);
    // fetchScenarioCollectionNew(filters);
    // fetchRegionData({});
  };

  const handleModal = (content, disableBackdropClick, disableEscapeKeyDown, forVariationSelection = false) => {
    setDisableBackdropClick(disableBackdropClick ? true : false);
    setDisableEscapeKeyDown(disableEscapeKeyDown ? true : false);
    setModalContent(content);
    setIsOpen(true);
    forVariationSelection && setModalForVariation(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleDeselect = (val) => {
    const {[val]: removedKey, ...rest} = selectHandleObj;
    const uuidToRemove = new Set(removedKey.map(item => item.scenario_uuid));
    const updatedCart = cartItems.filter(item => !uuidToRemove.has(item.scenario_uuid))
    setCartItems(updatedCart);
    setSelectHandleObj(rest);
  }

  const removeFromHandleObj = (date, uuid) => {
    const updatedArr = selectHandleObj[date].filter(item => item.scenario_uuid !== uuid);
    if (updatedArr.length === 0) {
      const {[date]: removedKey, ...rest} = selectHandleObj;
      setSelectHandleObj(rest);
    } else {
      setSelectHandleObj(preVal => ({
        ...preVal,
        [date]: updatedArr
      }));
    }
  }

  const removeItemForGroup = (rowData) => {
    const index = cartItems.findIndex(
      (row) => row.scenario_uuid === rowData.scenario_uuid
    );
    const newArray = [
      ...cartItems.slice(0, index),
      ...cartItems.slice(index + 1),
    ];
    setCartItems(newArray);
    newArray.length === 0 ? setSelectHandleObj({}) : removeFromHandleObj(`${rowData.date_from_folder}_${tabs[tabValue].key}`, rowData.scenario_uuid);
  }
  // const fetchScenarioCollectionNew = async (filters = currentFilters) => {
  //   setLoading(true);
  //   const response = await axios.post(`/fetch_open_loop_scenario_data`, {
  //     open_loop_type: "PR",
  //     page_number_record: page + 1,
  //     page_size_record: eventsPerPage,
  //     current_page: page + 1,
  //     is_deleted: false,
  //     searchOptions: filters ? filters : {},
  //   });
  //   setScenarioCollectionNew(response.data.data);

  //   setTotal(response.data.total_records);
  //   setLoading(false);
  // };

  const fetchRegionData = async ({index=0, options=tabs, page=1, eventsPerPage=10, filters = currentFilters}) => {
    if(options.length){
      setIsLoading(true)
      const regionResponse = await axios.post(
        // `http://localhost:3010/fetch_scenario_by_region?region=${options[index].key}`
        "cm/open_loop/fetch_scenario_by_region",
          {
            "open_loop_type": "PR",
            "page_number_record": page,
            "page_size_record": eventsPerPage,
            "region": options[index].key,
            searchOptions: filters ? filters : {},
            sort_field_record: sortField,
            sort_order_record: sortOrder

        }
      );
      setTotal(regionResponse.data.total_records);
      setRegionData(regionResponse.data.data)
      setIsLoading(false);
    }
  }

  const fetchCountryTabs = async () => {
    try{
      setIsLoading(true);
      const response = await axios.post(
        // "http://localhost:3010/fetch_countries_for_pr"
        "/cm/open_loop/fetch_region"
      );
      
      const tabs = response.data;
      await fetchRegionData({options:tabs});
      setTabs(tabs);
    } catch(error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
    
  } 

  useEffect(() => {
    // fetchSelectOptions();
    fetchFilterOptions();
    fetchCountryTabs();
  }, []);

  // useEffect(() => {
  //   selectValue && fetchScenarioCollectionNew(JSON.stringify([{ model_name: [selectValue] }, currentFilters]));
  // }, [eventsPerPage, page, selectValue]);

  const handleSelectAll = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
      //   '/cm/close_loop/select-data-for-grouping',
      //   {
      //     searchOptions: currentFilters,
      //   }
      // );
      '/cm/open_loop/fetch_scenario_for_pr_grouping',
      {
        "searchOptions": currentFilters,
        "open_loop_type":"PR",
        "region": tabs[tabValue].key
      }
      );
      const arrItems = [...cartItems, ...response.data.data];
      const uniqueItems = Array.from(
        new Map(arrItems.map(item => [item.scenario_uuid, item])).values()
      );
      setCartItems(uniqueItems);
      const groupedObj = response.data.data.reduce((acc, obj) => {
        const prefix = `${obj.date_from_folder}_${tabs[tabValue].key}`;
        if (!acc[prefix]) {
          acc[prefix] = [];
        }
        acc[prefix].push(obj);
        return acc;
      }, {});
      setSelectHandleObj({...selectHandleObj, ...groupedObj});
      response.data.data.length !== 0 && handleModal(
        <ScenarioGroupingFlow
          cartItems={uniqueItems}
          onRemoveFromCart={removeItemForGroup}
          clearCart={() => {
              setCartItems([]);
              setRegionDateAllSelect({})
              setIsOpen(false);
            }
          }
          handleCloseModal={setIsOpen}
          selectValue={selectValue}
          open_loop_type={"PR"}
        ></ScenarioGroupingFlow>,
        true,
        true
      )
    } catch(err) {
      console.error('error message', err)
    } 
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(tabs.length){
      fetchRegionData({eventsPerPage, page:page+1, index:tabValue, filters:currentFilters});
    }
  }, [eventsPerPage, page, currentFilters,sortOrder,sortField]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [cartItems, approveLoading, tabs, tabValue, selectHandleObj, selectValue]);

  const handleAddToCart = async (scenario, tabs, tabValue) => {
    console.log("scenerio", scenario, tabs, tabValue);
    setRegionDateAllSelect((previousSelect) =>({
      ...previousSelect,
      [scenario.scenario_uuid]: true
    }) )

    const response = await axios.post(
      // `http://localhost:3010/fetch_pr_data_for_date?region=${scenario.region}&date=${scenario.date}`
      "/cm/open_loop/fetch_scenario_by_date",
      {
        "open_loop_type": "PR",
        // "page_number_record": 1,
        // "page_size_record": 10,
        "region": tabs[tabValue].key,
        "timestamp": scenario.date_from_folder
    }
    );
    
    console.log("handleAddToCart", response)
    if (!!response.data.data.length) {
      setCartItems((prev) => [...prev, ...response.data.data]);
    }
  };

  const handleRemoveFromCart = (scenario, tabs, tabValue) => {
    console.log("scenerio1", scenario, tabs, tabValue);
    setRegionDateAllSelect(async (previousSelect) => {
      const newObj = {
        ...previousSelect,
        [scenario.scenario_uuid]: false,
      };
      const response = await axios.post(
        // `http://localhost:3010/fetch_pr_data_for_date?region=${scenario.region}&date=${scenario.date}`
        "/cm/open_loop/fetch_scenario_by_date",
      {
        "open_loop_type": "PR",
        "page_number_record": 1,
        "page_size_record": 10,
        "region": tabs[tabValue].key,
        "timestamp": scenario.date_from_folder
    }
      );
      
      console.log("handleRemove From cart", response)
      if (!!response.data.data.length) {
          setCartItems((prev) => {
              return prev.filter((field) => !response.data.data.some((resField) => resField.scenario_uuid === field.scenario_uuid))
          });
      }
  
      return newObj;
  })
    
  };

  const handleApprove = async (scenarioUuid, data_type) => {
    try {
      setApproveList((prevList) => {
        return [...prevList, scenarioUuid];
      });
      setApproveLoading(true);
      await axios.post(`/cm/open_loop/move-file`, {
        scenario_uuid: scenarioUuid,
        delete_flag: "False",
        data_type: data_type,
      });
      // fetchScenarioCollectionNew();
    } catch (error) {
      console.error("Failed to approve the data:", error);
    } finally {
      setApproveList((prevEle) => {
        const newArr = prevEle.filter((ele) => ele !== scenarioUuid);
        return newArr;
      });
      setApproveLoading(false);
    }
  };

  const updateCart = (obj, mode, resetVal = false) => {
    resetVal && setAllSelect(false);
    if (mode === "add") {
      // handleAddToCart(obj);
      setCartItems((prevCart) => {
        const newCart = prevCart.some(
          (item) => item.scenario_uuid === obj.scenario_uuid
        )
          ? prevCart
          : [...prevCart, obj];
        return newCart;
      });
    } else {
      // handleRemoveFromCart(obj);
      setCartItems((prevCart) => {
        const newCart = prevCart.filter(
          (item) => item.scenario_uuid !== obj
        );
        return newCart;
      });
    }
  }



console.log("columns", columns, regionData);
  return (
    <div
      style={{
        padding: "0.6rem",
        position: "relative",
        background: "white",
        margin: "10px",
        borderRadius: "10px",
        height: "calc(100% - 120px)"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "white",
          padding: "5px",
          width: "100%",
        }}
      >
        <Typography variant="h5">
          <Link to="/welcome">Open Loop </Link> {">"} PR {">"} Base Scenario
          Collection
        </Typography>
        <div>
        <Button
            onClick={handleSelectAll}
            variant="contained"
            style={{
              backgroundColor: allSelected ? "rgba(0,0,0,.1)" : "#622AD8",
              color: allSelected ? "#000000" : "#ffffff",
            }}
          >
            Select All
          </Button>
          <Tooltip placement="top" title={<h6>Handle Cart</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <ScenarioGroupingFlow
                    cartItems={cartItems}
                    onRemoveFromCart={() => {}}
                    clearCart={() => {
                      setCartItems([]);
                      setIsOpen(false);
                      setSelectHandleObj({});
                      setRegionDateAllSelect({});
                    }
                  }
                    handleCloseModal={setIsOpen}
                    selectValue={selectValue}
                    open_loop_type={"PR"}
                  ></ScenarioGroupingFlow>,
                  true,
                  true
                )
              }
            >
              <Badge
                badgeContent={cartItems.length}
                max={5000}
                color="secondary"
              >
                <NoteAddIcon />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title={<h6>Help</h6>}>
            <IconButton
              color="inherit"
              onClick={() =>
                handleModal(
                  <HelperComponent
                    closeHandler={setIsOpen}
                    contentController={[
                      {
                        value: "tutorialVideo",
                        label: "Tutorial",
                        tutorials: [{
                        videoURL: "/video/openlooppr.mp4",
                        text: "In this tutorial, we will have a walkthrough on how to use the open loop PG Scenario Collection.",
                        title: "Open loop | PR | Base Scenario Collection"}]
                      },
                    ]}
                    defaultSelector="tutorialVideo"
                  />,
                  true,
                  true
                )
              }
            >
              <Badge max={5000} color="secondary">
                <HelpIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          {selectedRows.length !== 0 && (
            <Tooltip placement="top" title={<h6>Download</h6>}>
              <IconButton color="inherit" onClick={() => setDownloadConfirm(true)}>
                <Badge
                  badgeContent={selectedRows.length}
                  max={5000}
                  color="secondary"
                >
                  <CloudDownloadIcon />
                </Badge>
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      <Divider />

      {/* <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={"lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      /> */}
       <Modal
        title={modalForVariation && 'Add count'}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={modalForVariation ? "sm" : "lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
        heightVal={modalForVariation ? '350px' : '580px'}
      />
      {isBulkDownloadPopupOpen && <BulkDownloadModal
        title={modalForVariation ? "Cart updated successfully" : "Bulk Download Status"}
        isOpen={isBulkDownloadPopupOpen}
        onClosePopup={modalForVariation ? onClickClose : onCloseBulkDownloadPopup}
        content={bulkDownloadRes.body}
      />}
      {downloadConfirm && <BulkDownloadConfirmationModal
        isOpen={downloadConfirm}
        onClosePopup={setDownloadConfirm}
        onClickYes={bulkDownload}
      />}
      <AppBar position="static">
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="pr tabs"
        >
          {
            tabs.map((tab, index) => (
              <Tab label={tab.key} {...a11yProps(index)} />
            ))
          }
        </Tabs>
      </AppBar>
        {
          tabs.map((tab, index) => ( <TabPanel value={tabValue} index={index}>
            <Grid
        container
        style={{
          marginTop: "24px",
          padding:"0",
          marginBottom: "5px",
          justifyContent: "space-between",
        }}
      >
         <Grid item>
         {/* Filter Button */}
       {/* {Object.keys(options).length ? */}
       <Fragment>
              <Button
                onClick={() =>
                  handleModal(
                    <ConditionalFilter
                      handleClose={handleClose}
                      options={options}
                      handleAdvancedFilterSearch={handleAdvancedFilterSearch}
                      preSelectedFilters={savedFilters}
                    />
                  )
                }
                variant="contained"
                style={{ backgroundColor: "#622ad8", color: "white" }}
                startIcon={<FilterList />}
              >
                Filter
              </Button> 
                <Button
                onClick={handleResetForm}
                variant="outlined"
                startIcon={<ClearIcon />}
              >
                Clear
              </Button>
              </Fragment>
              {/* : null} */}

               {/* Clear */}
           
          </Grid>

        <Grid item>
          <CustomPagination
            total={total}
            rowsPerPageOptions={rowsPerPageSessionBased}
            eventsPerPage={eventsPerPage}
            page={page}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            onPageChange={handlePageChange}
          />
        </Grid>
      </Grid>
      <div style={{ overflowX: "auto" }}>
        {columns.length > 0 ? (
          <StyledDataTable
            // selectableRows
            // onSelectedRowsChange={handleChange}
            // selectableRowSelected={(row) =>
            //   selectedRows.some((obj) =>
            //     Object.keys(obj).some((key) => obj[key] === row.scenario_uuid)
            //   )
            // }
            // clearSelectedRows={clearRows}
            columns={columns}
            data={regionData}
            onSort={handleSort}
            sortServer
            customStyles={customStyles}
            onRowClicked={(row) => setCurrentRowSelection(row)}
            expandableRowExpanded={(rowex) => (rowex === currentRowSelection)}
            onRowExpandToggled={(bool, row) => setCurrentRowSelection(row)}
            expandableRowsComponent={
              <PRScenarioLogicalNameListing
                updateCart={updateCart}
                selectedRows={selectedRows}
                cartItems={cartItems}
                addToCart={addItemsForGroup}
                handleRemoveFromCart={removeItemForGroup}
                allSelect={allSelect}
                onSelectRow={onSelectRow}
                onSelectAllRow={selectAll}
                region={tabs[tabValue] && tabs[tabValue].key}
                onDeselectAllRow={deselectAll}
                clearRows={clearRows}
                regionDateAllSelect={regionDateAllSelect}
                setRegionDateAllSelect={setRegionDateAllSelect}
                preSelectedFilters={currentFilters}
              />
            }
            expandableRows
          ></StyledDataTable>
        ) : null}

        {/* <CMDeleteModal
          open={confirmDeleteOpen}
          message="Are you sure you want to delete this scenario?"
          onCancel={() => setConfirmDeleteOpen(false)}
          onConfirm={() => handleDelete(deleteScenarioUuid)}
        /> */}
      </div>
      </TabPanel>))
        }

      

      
    </div>
  );
}

export default PRScenarioListing;